import React, { Fragment } from 'react';
import { string, func } from 'prop-types';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import { withMediaQuery } from 'common/utils';

import styles from '../LandingSkinnyBanner.css';

const SkinnyDescription = ({ link, onClick, text }) => {
  const props = [
    {
      minWidth: 1600,
      size: 'l',
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      onClick: onClick,
      withBouncing: true,
      children: link
    },
    {
      maxWidth: 1599,
      minWidth: 1025,
      size: 'm',
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      onClick: onClick,
      withBouncing: true,
      children: link
    },
    {
      maxWidth: 1024,
      size: 's',
      icon: { direction: 'right', name: 'link-arrow-right-17', type: 'other' },
      onClick: onClick,
      withBouncing: true,
      children: link
    }
  ];

  return (
    <Fragment>
      <p className={styles.description}>{text}</p>
      {withMediaQuery(LinkFreeStanding, props)}
    </Fragment>
  );
};

SkinnyDescription.propTypes = {
  link: string,
  onClick: func,
  text: string,
};

SkinnyDescription.displayName = 'SkinnyDescription';

export default SkinnyDescription;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/SkinnyBanner/Landing/SkinnyDescription/SkinnyDescription.js